import axios from "axios";
import { config } from "../../config/appConfig";

export const PASSWORD = {
  tokenRequest: {
    success: "PASSWORD_TOKEN_SUCCESS",
    error: "PASSWORD_TOKEN_ERROR"
  },
  resetRequest: {
    success: "PASSWORD_RESET_SUCCESS",
    error: "PASSWORD_RESET_ERROR"
  }
};

export const tokenRequestAction = userEmail => {
  let url = `${config.BASE_URL}/ntrac/user/forgot-password`;
  return dispatch => {
    axios
      .post(url, userEmail, {
        headers: {
          "Content-Type": "application/json"
        }
      })
      .then(response => {
        console.log(response.data.message);
        dispatch({
          type: PASSWORD.tokenRequest.success,
          data: response.data
        });
      })
      .catch(err => {
        dispatch({
          type: PASSWORD.tokenRequest.error,
          data: err.response.data
        });
      });
  };
};

export const resetRequestAction = resetPassword => {
  let url = `${config.BASE_URL}/ntrac/user/reset-password`;
  return dispatch => {
    axios
      .put(url, resetPassword, {
        headers: {
          "Content-Type": "application/json"
        }
      })
      .then(response => {
        dispatch({
          type: PASSWORD.resetRequest.success,
          data: response.data
        });
      })
      .catch(err => {
        dispatch({
          type: PASSWORD.resetRequest.error,
          data: err.response.data
        });
      });
  };
};



// WEBPACK FOOTER //
// ./src/modules/forgotPassword/action.js